import axiosPost from "../axiosPost";

export const migraPasoGet = async (
    { migraPasoId = null, migraTipoDePasoId, migraPasoNombre, migraPasoStatus } = {},
    credentials
) => {
    const params = {
        merchantId: credentials.merchantId,
        migraPasoId,
    };
    if (migraTipoDePasoId != null && migraTipoDePasoId !== "") {
        params.migraTipoDePasoId = Number(migraTipoDePasoId);
    }
    if (migraPasoNombre) params.migraPasoNombre = migraPasoNombre;
    if (migraPasoStatus) params.migraPasoStatus = migraPasoStatus;

    const body = {
        service: "MigraPasoGet",
        params,
    };

    return await axiosPost(body, credentials);
};
